// supabaseService.js
import { supabase, withRetry } from './supabaseClient';
import moment from 'moment';

export const supabaseDataService = {

    getFeeds: async (userid, from, to) => {
        return withRetry(async () => {
            const { data, error } = await supabase
                .from('feed')
                .select()
                .eq('uid', userid)
                .order('created_at', { ascending: false })
                .order('id', { ascending: false })
                .range(from, to);

            if (error) throw error;
            return data;
        });
    },

    getEvents: async (userid, date) => {
        return withRetry(async () => {
            const momentDate = moment(date);
            const day = momentDate.clone().startOf('day');

            const { data, error } = await supabase
                .rpc('get_events_with_submissions', {
                    p_uid: userid,
                    p_start_date: day.format('YYYY-MM-DD')
                });

            if (error) throw error;
            console.log('[getEventsNew]data----->',data);
            return data;
        });
    },

    getEventsX: async (userid, date) => {
        return withRetry(async () => {
            const momentDate = moment(date);
            const day = momentDate.clone().startOf('day');

            console.log('[getEvents]--userid--->',userid);
            console.log('[getEvents]--start_date--->',day.format('YYYY-MM-DD'));

            const { data, error } = await supabase
                .from('events')
                .select()
                .eq('uid', userid)
                .eq('start_date', day.format('YYYY-MM-DD'))
                .order('start_date', { ascending: true })
                .order('start_time', { ascending: true });

            console.log('[getEventsOrig]data----->',data);
            if (error) throw error;
            return data;
        });
    },

    getTasks: async (userid, from, to) => {
        return withRetry(async () => {
            const { data, error } = await supabase
                .from('tasks')
                .select()
                .eq('uid', userid)
                .not('status', 'ilike', 'completed')
                .order('created_at', { ascending: false })
                .order('task_id', { ascending: false })
                .range(from, to);

            if (error) throw error;
            return data;
        });
    },

    updateTask: async (taskId, taskData) => {
        console.log('[updateTask]--taskData--->',taskData);
        return withRetry(async () => {
            const { data, error } = await supabase
                .from('tasks')
                .update(taskData)
                .eq('task_id', taskId)
                .select();

            if (error) throw error;
            return data[0];
        });
    },

    deleteTask: async (taskId) => {
        return withRetry(async () => {
            const { data, error } = await supabase
                .from('tasks')
                .delete()
                .eq('task_id', taskId)

            if (error) throw error;
            return;
        });
    },

    createSubmission: async (submissionData) => {
        return withRetry(async () => {
            const { data, error } = await supabase
                .from('submissions')
                .insert(submissionData)
                .select();

            if (error) throw error;
            return data[0];
        });
    },

    updateSubmission: async (submissionId, updates) => {
        return withRetry(async () => {
            const { data, error } = await supabase
                .from('submissions')
                .update(updates)
                .eq('id', submissionId)
                .select();

            if (error) throw error;
            return data[0];
        });
    },

    deleteSubmission: async (submissionId) => {
            const { data, error } = await supabase
                .from('submissions')
                .delete()
                .eq('submission_id', submissionId)

            if (error) throw error;
            return;
    },

    createFeed: async (feedData) => {
        return withRetry(async () => {
            const { data, error } = await supabase
                .from('feed')
                .insert(feedData)
                .select();

            if (error) throw error;
            return data[0];
        });
    },

    getUserByFirebaseUid: async (firebaseUid) => {
        return withRetry(async () => {
            const { data, error } = await supabase
                .from('users')
                .select()
                .eq('firebase_uid', firebaseUid)
                .single();

            if (error && error.code !== 'PGRST116') throw error;
            return data;
        });
    },

    createOrUpdateUser: async (userData) => {
        return withRetry(async () => {
            const { data, error } = await supabase
                .from('users')
                .upsert(userData, {
                    onConflict: 'firebase_uid',
                    ignoreDuplicates: false
                })
                .select();

            if (error) throw error;
            return data[0];
        });
    },

    createGroup: async (groupData) => {
        return withRetry(async () => {
            const { data, error } = await supabase
                .from('groups')
                .upsert(groupData, {
                    ignoreDuplicates: false
                })
                .select();

            if (error) throw error;
            return data[0];
        });
    },

    addMemberToGroup: async (group_id, uid, role_id, sendInvite = false) => {
        return withRetry(async () => {
            const memberData = {
                group_id: group_id,
                uid: uid,
                role_id: role_id
            };
            console.log('--memberData--->', memberData);

            const { data, error } = await supabase
                .from('group_members')
                .upsert(memberData, {
                    ignoreDuplicates: false
                })
                .select();

            if (error) throw error;
            return data[0];
        });
    },

    getGroupByName: async (group_name) => {
        return withRetry(async () => {
            const { data, error } = await supabase
                .from('groups')
                .select()
                .ilike('group_name', group_name);

            if (error) throw error;
            return data;
        });
    },

    getGroupForUser: async (uid) => {
        return withRetry(async () => {
            const { data, error } = await supabase
                .from('groups')
                .select(`*,group_members!inner (*)`)
                .eq('group_members.uid', uid)
                .in('group_members.role_id', [0, 1]);
            if (error) throw error;
            return data;
        });
    },

    getGroupsForUser: async (uid) => {
        return withRetry(async () => {
            const { data, error } = await supabase
                .from('groups')
                .select(`*,group_members!inner (*)`)
                .eq('group_members.uid', uid)
                .in('group_members.role_id', [2]);
            if (error) throw error;
            return data;
        });
    },

    getGroupMembers: async (group_id) => {
        return withRetry(async () => {
            const { data, error } = await supabase
                .from('group_members')
                .select(`*`)
                .eq('group_id', group_id);

            if (error) throw error;
            return data;
        });
    },

    getSubmissions: async (uid, from, to) => {
        return withRetry(async () => {
            const { data, error } = await supabase
                .from('submissions')
                .select(`
                    *,
                    submissions_categories (
                        category_id
                    ),
                    group_submissions (
                        group_id
                    )
                `)
                .eq('uid', uid)
                .order('created_at', { ascending: false })
                .range(from, to);

            if (error) throw error;
            return data;
        });
    },

    getCategories: async (uid) => {
        return withRetry(async () => {
            const { data, error } = await supabase
                .rpc('get_categories_by_uid', { uid: uid });

            if (error) throw error;
            return data.map(row => row.category);
        });
    },

    saveNotificationToken: async (uid, token, groupID) => {
        return withRetry(async () => {
            const { data, error } = await supabase
                .from('device_tokens')
                .upsert({
                    uid: uid,
                    token: token,
                    group_id: groupID,
                    platform: 'web',
                    created_at: new Date(),
                    updated_at: new Date()
                }, {
                    onConflict: 'uid,token'
                });
            if (error) throw error;
            return data;
        });
    },

    removeTokenFromDatabase: async (uid, token) => {
        return withRetry(async () => {
            const { error } = await supabase
                .from('device_tokens')
                .delete()
                .eq('uid', uid)
                .eq('token', token);

            if (error) throw error;
        });
    },

    getUserNotificationTokens: async (uid) => {
        return withRetry(async () => {
            const { data, error } = await supabase
                .from('device_tokens')
                .select('token')
                .eq('uid', uid);

            if (error) throw error;
            return data;
        });
    }

};
